import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { LINKS } from '../constants/links';
import '../styles/Login.css';
import '../styles/Landing.css';

const PUBLIC_URL = process.env.PUBLIC_URL || '';
const LOGO_SRC = `${PUBLIC_URL}/logo.png`;
const HERO_SRC = `${PUBLIC_URL}/banner-shedule.png?v=1`;
const ISO_CUBE = `${PUBLIC_URL}/iso-cube-clear.png`;
const ISO_PYRAMID = `${PUBLIC_URL}/iso-pyramid-clear.png`;

const Landing = () => {
  const [iosOpen, setIosOpen] = useState(false);

  useEffect(() => {
    if (!iosOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [iosOpen]);

  const iosDialog = iosOpen && typeof document !== 'undefined'
    ? createPortal(
      <div className="landing-ios" role="dialog" aria-modal="true" aria-labelledby="iosTitle">
        <div className="landing-ios__card">
          <h2 id="iosTitle">Как открыть на iPhone</h2>
          <ol>
            <li>Откройте расписание в <strong>Safari</strong>.</li>
            <li>Нажмите кнопку <strong>Поделиться</strong>.</li>
            <li>Выберите <strong>На экран «Домой»</strong>.</li>
            <li>Подтвердите — иконка появится рядом с другими приложениями.</li>
          </ol>
          <p className="landing-ios__note">В App Store отдельного приложения нет: это веб-версия на домашнем экране.</p>
          <button type="button" className="kkt-btn" onClick={() => setIosOpen(false)}>Понятно</button>
        </div>
      </div>,
      document.body
    )
    : null;

  return (
    <div className="kkt-shell landing-shell">
      <div className="kkt-bg" aria-hidden="true">
        <div className="kkt-bg__blob kkt-bg__blob--1"></div>
        <div className="kkt-bg__blob kkt-bg__blob--2"></div>
        <div className="kkt-bg__blob kkt-bg__blob--3"></div>
        <img className="kkt-bg__iso kkt-bg__iso--cube-1" src={ISO_CUBE} alt="" decoding="async" />
        <img className="kkt-bg__iso kkt-bg__iso--pyramid-1" src={ISO_PYRAMID} alt="" decoding="async" />
        <img className="kkt-bg__iso kkt-bg__iso--cube-2" src={ISO_CUBE} alt="" decoding="async" />
        <img className="kkt-bg__iso kkt-bg__iso--pyramid-2" src={ISO_PYRAMID} alt="" decoding="async" />
        <img className="kkt-bg__iso kkt-bg__iso--cube-3" src={ISO_CUBE} alt="" decoding="async" />
      </div>

      <header className="kkt-top">
        <a className="kkt-logo" href="/#/">
          <img className="kkt-logo-img" src={LOGO_SRC} alt="Логотип" width="40" height="40" decoding="async" />
          Расписание
        </a>
        <a className="kkt-top-link" href="/#/login">Войти</a>
      </header>

      <main className="kkt-main">
        <div className="kkt-hero">
          <div className="kkt-panel">
            <h1>Расписание<br /><em>пары всегда под рукой</em></h1>
            <p>
              Смотрите расписание занятий Краснодарского кооперативного техникума
              в браузере или как приложение на телефоне.
            </p>
            <div className="kkt-actions">
              <a className="kkt-btn" href="/#/login">Веб-версия</a>
              <a className="kkt-btn-outline" href={LINKS.eo} target="_blank" rel="noopener noreferrer">
                Электронное обучение
              </a>
              <a
                className="kkt-btn-outline"
                href={LINKS.androidApk}
                download="kkt-schedule.apk"
              >
                Скачать для Android
              </a>
              <button type="button" className="kkt-btn-outline" onClick={() => setIosOpen(true)}>
                Инструкция для iOS
              </button>
            </div>
          </div>
          <div className="kkt-hero-visual">
            <img src={HERO_SRC} alt="" width="420" height="420" decoding="async" />
          </div>
        </div>
      </main>

      <footer className="kkt-bottom">Расписание</footer>

      {iosDialog}
    </div>
  );
};

export default Landing;
